import * as React from "react";
import { SVGProps } from "react";

export const ZoomInIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={25}
    height={25}
    fill="none"
    {...props}
  >
    <path
      fill="#2D5BFF"
      d="m18.531 17.117 4.283 4.282-1.415 1.415-4.282-4.283A8.96 8.96 0 0 1 11.5 20.5c-4.968 0-9-4.032-9-9s4.032-9 9-9 9 4.032 9 9a8.96 8.96 0 0 1-1.969 5.617Zm-2.006-.742A6.977 6.977 0 0 0 18.5 11.5c0-3.868-3.133-7-7-7-3.868 0-7 3.132-7 7 0 3.867 3.132 7 7 7a6.977 6.977 0 0 0 4.875-1.975l.15-.15ZM10.5 10.5v-3h2v3h3v2h-3v3h-2v-3h-3v-2h3Z"
    />
  </svg>
);
